import styled from 'styled-components';

import { BasicSubtitle } from '@genially/design-system';

export const Row = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: size.units(2),
}));

export const Label = styled(BasicSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));
